export default function PageNotFound() {
  return <div>404</div>;
}
